/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundVariantDto } from '../../models/backend-venture-fund-variant-dto';

export interface VentureFundsVentureFundVariantsList$Params {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  project?: number;

  /**
   * A search term.
   */
  search?: string;
}

export function ventureFundsVentureFundVariantsList(
  http: HttpClient,
  rootUrl: string,
  params?: VentureFundsVentureFundVariantsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendVentureFundVariantDto>>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundVariantsList.PATH, 'get');
  if (params) {
    rb.query('ordering', params.ordering, {});
    rb.query('project', params.project, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendVentureFundVariantDto>>;
    }),
  );
}

ventureFundsVentureFundVariantsList.PATH = '/api/venture_funds/venture-fund-variants/';
